<!-- <div  class="row">
<div class="col-md-4"> -->
  @if (isLoggedInAllSites && sitesIsLoaded && !_currentUser.isEnterprise) {
    <div class="form-group">
      <label class="control-label trl" for="siteCode">
        Site Code
      </label>
      <kendo-combobox #kendo_combo_SiteCode [data]="_sitesFiltered"
        [suggest]="true"
        class="MultiSiteCustomComboBox fullavailableWidthReport bordered"
        [textField]="'code'"
        [valueField]="'id'"
        [filterable]="true"
        (filterChange)="_handleSitesFilter($event)"
        (ngModelChange)="_handleSitesChange($event)"
        [(ngModel)]="_siteSelected">
      </kendo-combobox>
    </div>
  }
<!-- </div>
</div> -->
